import { create } from 'zustand';

import { TaskGroup } from 'models/task-groups.model';
import {
  DraftTaskGroup,
  TaskGroupsAction,
  TaskGroupsState,
} from './task-groups.type';
import { initialDraftTaskGroup } from './task-groups-initials';

const initialState: TaskGroupsState = {
  taskGroups: [],
  draftTaskGroup: initialDraftTaskGroup,
  selectedTaskGroup: null,
  isAlertShown: true,
  isControlsShown: true,
  isDraftTaskGroupValid: false,
};

export const useTaskGroupsStore = create<TaskGroupsState & TaskGroupsAction>(
  (set) => ({
    ...initialState,
    setTaskGroups: (taskGroups: TaskGroup[]) => set({ taskGroups }),
    setDraftTaskGroup: (draftTaskGroup: DraftTaskGroup) =>
      set({ draftTaskGroup }),
    setSelectedTaskGroup: (selectedTaskGroup: TaskGroup) =>
      set({ selectedTaskGroup }),
    setIsAlertShown: (isAlertShown: boolean) => set({ isAlertShown }),
    setIsControlsShown: (isControlsShown: boolean) => set({ isControlsShown }),
    setIsDraftTaskGroupValid: (isDraftTaskGroupValid: boolean) =>
      set({ isDraftTaskGroupValid }),
  }),
);

export const setTaskGroups = (taskGroups: TaskGroup[]) => {
  useTaskGroupsStore.setState({ taskGroups });
};

export const setDraftTaskGroup = (draftTaskGroup: DraftTaskGroup) => {
  useTaskGroupsStore.setState({ draftTaskGroup });
};

export const setSelectedTaskGroup = (selectedTaskGroup: TaskGroup) => {
  useTaskGroupsStore.setState({ selectedTaskGroup });
};

export const setIsAlertShown = (isAlertShown: boolean) => {
  useTaskGroupsStore.setState({ isAlertShown });
};

export const setIsControlsShown = (isControlsShown: boolean) => {
  useTaskGroupsStore.setState({ isControlsShown });
};

export const setIsDraftTaskGroupValid = (isDraftTaskGroupValid: boolean) => {
  useTaskGroupsStore.setState({ isDraftTaskGroupValid });
};

export const resetDraftTaskGroup = () => {
  useTaskGroupsStore.setState({
    draftTaskGroup: initialState.draftTaskGroup,
    selectedTaskGroup: initialState.selectedTaskGroup,
    isDraftTaskGroupValid: initialState.isDraftTaskGroupValid,
    isControlsShown: initialState.isControlsShown,
  });
};
